module.exports = __webpack_public_path__ + "img/nota-fiscal.f743d02f.svg";